import {Autocomplete, Box, createFilterOptions, TextField} from "@mui/material";
import React from "react";
import {AutocompleteProps} from "../../components/SearchBox";
import {OperationApiGet, useGetOperationQuery} from "./operation_api";
import {Tables} from "../../apitypes";
import AvatarImage from "../storage/AvatarImage";


export default ({setFieldValue, value, name, error, label}: AutocompleteProps<OperationApiGet>) => {

    const {data} = useGetOperationQuery({active: true});

    return <Autocomplete
        id={name}
        options={data || []}
        sx={{minWidth: "150px"}}
        value={value}
        onChange={(e, v: OperationApiGet | null) => {
            setFieldValue(name, v)
        }}
        getOptionLabel={(option: OperationApiGet) => {
            return option.Name;
        }}
        getOptionKey={o => o.id}
        filterOptions={createFilterOptions({
            stringify: (option) => option.Name + " " + option.Code,
        })}
        renderOption={(props, option: OperationApiGet) => {
            const {key, ...rest} = props
            return <Box key={key} component="li" sx={{'& > .MuiAvatar-root': {mr: 1}}} {...rest}>
                <AvatarImage image_url={option.image_url} bucket={"machines"}/> {option.Code} {option.Name}
            </Box>
        }}
        renderInput={(params) => (
            <TextField
                {...params}
                label={label}
                error={Boolean(error)}
                helperText={error}
            />
        )}
    />

}
